import { useCallback, useEffect, useState } from "react";
import { ApiCall } from "../../../helper/axios";

let staticDataCache = null;
let staticDataPromise = null;

export const useGetHotelStaticData = () => {
  const [details, setData] = useState(staticDataCache);
  const [loading, setLoading] = useState(false);

  const refreshData = useCallback(async () => {
    if (staticDataCache) {
      setData(staticDataCache);
      return;
    }

    if (!staticDataPromise) {
      setLoading(true);
      staticDataPromise = ApiCall(
        "GET",
        `/hotels/static-data?timeZone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`
      );
    }

    try {
      const response = await staticDataPromise;
      if (response?.status === 200 && response?.data?.statusCode === 200) {
        const data = response.data.data;
        staticDataCache = data;
        sessionStorage.setItem("Cities", JSON.stringify(data?.cities));
        setData(data);
      }
    } catch (error) {
      // Keep existing behavior: silently ignore errors
    } finally {
      if (staticDataPromise) {
        staticDataPromise = null;
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  return {
    loading,
    details,
  };
};

export const clearStaticDataCache = () => {
  staticDataCache = null;
  staticDataPromise = null;
};
